/*
* Project: LegalPlace assistant
* File: src/logic/history.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/


// manipulating history
// assert that every step we save the actuial the state.
// The titles are predefined * - LegalPlace
// douments: Statut SASU - Modèle de status SASU rédigé par des avocats - LegalPlace ->


import { store } from '../globals';
import lpApp from '../app/lp_app';
import History from './utils/history';

// definition of the links and titles


class LinkState {
  constructor(title, link) {
    this.title = title;
    this.link = link;
  }


  getTitle() {
    return this.title;
  }

  getLink() {
    return this.link;
  }
}

class LinkContract extends LinkState {
  constructor(section) {
    super('Création de votre document - LegalPlace', `/contrats/${window.contractName}/creer/${section + 1}`);
    console.log("section ===>", section)
  }
}

class LinkContractContinue extends LinkState {
  constructor(id, section) {
    super('Création de votre document - LegalPlace', `/contrats/${window.contractName}/continuer/${id}/${section + 1}`);
  }
}

class LinkContractPayment extends LinkState {
  constructor(id) {
    super('Création de votre document - LegalPlace', `/contrats/${window.contractName}/${id}/paiement`);
  }
}

class LinkContractExpertComptable extends LinkState {
  constructor(id) {
    super('Création de votre document - LegalPlace', `/contrats/${window.contractName}/${id}/expert-comptable`);
  }
}

class LinkContractContinuePayment extends LinkState {
  constructor(id) {
    super('Création de votre document - LegalPlace', `/contrats/${window.contractName}/${id}/paiement`);
  }
}

class LinkContractPaymentCheckout extends LinkState {
  constructor(id) {
    super('Création de votre document - LegalPlace', `/contrats/${window.contractName}/${id}/checkout`);
  }
}

// The model of our state is: type: (new|continue), docid: (if continue), section: nbr

function getStateByHref(href) {
  const data = href.split('/');
  // let contrcats = data[1];
  // let name = data[2];
  const type = data[1];
  const arg1 = data[2];
  //
  const result = { continue: false, doc_id: '', section: -1 };
  if (type === 'continuer') {
    const arg2 = data[3];
    result.continue = true;
    result.doc_id = arg1;
    result.section = arg2;
  } else {
    result.continue = false;
    result.section = arg1;
  }
  return result;
}

// changes are in section-id
function writeHistory(state, cont, section, id = '') {
  let link;
  if (cont) {
    if (state === 'payment') {
      link = new LinkContractContinuePayment(id);
    } else if(state === 'checkout') {
      link = new LinkContractPaymentCheckout(id);
    } else {
      link = new LinkContractContinue(id, section);
    }
  } else if (state === 'payment') {
    link = new LinkContractPayment(id);
  } else if (state === 'expert-comptable') {
    link = new LinkContractExpertComptable(id);
  } else if (state === 'checkout') {
    link = new LinkContractPaymentCheckout(id);
  } else {
    link = new LinkContract(section);
  }
  // cons ole.log(link)
  // setup the push
  if (window.lpApp && window.lpApp.isPrerender) return;
  History.history.push(link.getLink());
 // window.history.pushState({ store: { section, app_state: state === 'payment' ? 1 : 0 }, s_id: store.getState().contract.currentSection }, link.getTitle(), link.getLink());
  document.title = link.getTitle();
  // cons ole.log(link)
  // setup the push
  if(window.lpApp && window.lpApp.is_prerender) return;
  if(!lpApp.mutex.checkMutex('links'))return;
  // window.history.pushState({store: {section: section, app_state: state == 'payment' ? 1 : 0 }, s_id: store.getState().contract.current_section}, link.getTitle(), link.getLink());
  document.title = link.getTitle();
}

window.writeHistory = writeHistory;
window.detectHistory = getStateByHref;
// TODO: Every single action must write history
// setup the thing


export default writeHistory;



// WEBPACK FOOTER //
// ./src/logic/history.js